import React, { createContext, useRef, useState } from "react"
import AikaTipsFAB from "../components/compounds/AikaTipsFAB.compound"
import { ReactComponent as LightbulbIcon } from "../design/assests/images/icons/lightbulb2.svg"
import useToast from "../hooks/useToast.hook"
import { generateRandomId } from "../utils/strings.utils"

export const AikaTipsContext = createContext()

export const AikaTipsProvider = ({ children }) => {
  const onClickRef = useRef(() => {})
  const [visible, setVisible] = useState(false)
  const [isTipActive, setIsTipActive] = useState(false)
  const { setMessageBR } = useToast()
  const [message, setMessage] = useState(<></>)
  const [onToastClose, setOnToastClose] = useState(() => {})

  function hideFAB() {
    setVisible(false)
    setIsTipActive(false)
  }

  function showFAB() {
    setVisible(true)
  }

  function RenderMessage() {
    const uid = generateRandomId()

    function handleTrueClose() {
      // NOTE: Prime provides no "onToastClose" event, this is a workaround
      const primeCloseIcon = document.querySelector(
        `.p-toast-icon-close.p-link:not(#close-button-${uid})`
      )
      if (primeCloseIcon) {
        onToastClose()
        primeCloseIcon.click()
      }
    }

    return (
      <div id={uid} className="aika-tips-message">
        <div>
          <button
            type="button"
            id={`close-button-${uid}`}
            className="p-toast-icon-close p-link intercept-close-button"
            aria-label="Close"
            onClick={handleTrueClose}
          >
            <span
              className="p-toast-icon-close-icon pi pi-times"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        {message}
      </div>
    )
  }

  return (
    <AikaTipsContext.Provider
      value={{
        hideFAB,
        showFAB,
        onClickRef,
        setMessage,
        setIsTipActive,
        isTipActive,
        setOnToastClose,
      }}
    >
      {children}
      {visible && (
        <AikaTipsFAB
          onClick={() => {
            setIsTipActive(true)
            onClickRef.current()
            setMessageBR({
              headline: "¡AIKA Tips!",
              message: <RenderMessage />,
              lifeTime: 1000 * 1000 * 1000,
              icon: <LightbulbIcon className="m-auto aika-tips-icon" />,
            })
          }}
        />
      )}
    </AikaTipsContext.Provider>
  )
}
